import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { HiOutlineArrowUpTray, HiMagnifyingGlass } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";
import { fixMonthDisplay } from "../../../Utils/utilServices";

const formatDateInput = (date) => date.toISOString().split("T")[0];

const columns = [
  { field: "orderId", header: "Order ID" },
  { field: "enquiryId", header: "Enquiry ID" },
  { field: "uniqueCode", header: "Enquiry Code" },
  { field: "txnId", header: "Txn Id" },
  { field: "patientName", header: "Patient Name" },
  { field: "patientId", header: "Patient ID" },
  { field: "patientMobile", header: "Patient Mobile" },
  { field: "patientAddress", header: "Patient Address" },
  { field: "billingName", header: "Billing Eclinic Name" },
  { field: "billingAddress", header: "Billing Eclinic Address" },
  { field: "billingContactNumber", header: "Billing Eclinic Contact No" },
  { field: "shipTo", header: "Ship To" },
  { field: "shippingPartnerName", header: "Shipping Name" },
  { field: "shippingAddress", header: "Shipping Address" },
  { field: "shippingContactNumber", header: "Shipping Contact No" },
  { field: "drugCode", header: "Drug Code" },
  { field: "drugName", header: "Drug Name" },
  { field: "drugsInfoTypeofsell", header: "Package Size" },
  { field: "quantity", header: "Quantity" },
  { field: "unitPrice", header: "Unit Price (INR)" },
  { field: "totalAmount", header: "Total Amount (INR)" },
  { field: "eclinicName", header: "Eclinic Name" },
  { field: "confirmedDate", header: "Date & Time of Response" },
  { field: "type", header: "Type Of Order " },
  { field: "billingDate", header: "Order Confirmation/Bill Date & Time" },
  { field: "txnId", header: "Bill / invoice number" },
  { field: "drugCode", header: "Billed Drug Code" },
  { field: "drugName", header: " Billed Drug Name" },
  { field: "quantity", header: "Billed Drug Quantity" },
  { field: "unitPrice", header: "Billed Unit Price (INR)" },
  { field: "totalAmount", header: "Billed Total Amount (INR)" },
  { field: "consignmentId", header: "Consignment ID" },
  { field: "consignmentDate", header: "Consigment Received time" },
  { field: "procedureStatus", header: "Status" },
  { field: "orderCanceledSource", header: "Cancellation Source" },
  { field: "sentToSaveo", header: "Order Processing Method" },
];

const stateList = [
  { name: "Odisha", value: "OD" },
  { name: "Chhattisgarh", value: "CG" },
  { name: "Jharkhand", value: "JH" }
];

const CheEngageOrderReports = () => {
  const today = new Date();
  const twoDaysAgo = new Date();
  twoDaysAgo.setDate(today.getDate() - 2);

  const user = JSON.parse(localStorage.getItem("loginObj"));
  const [loggedInUser] = useState(
    user.userRolesList.find(
      (user) => user.roleCode === "PHHEAD" || user.roleCode === "PH"
    )
  );
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [defaultWHList, setdefaultWHList] = useState([]);
  const [warehouseList, setwarehouseList] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const warehouseDropdownRef = useRef(null);
  const [filters, setFilters] = useState({
    reportType: "CHE/Engage",
    state:
      loggedInUser?.roleCode != "PHHEAD"
        ? localStorage.getItem("userState")
        : "OD",
    fromDate: formatDateInput(twoDaysAgo),
    toDate: formatDateInput(today),
    orderId: "",
    enquiryId: "",
    patientId: "",
    circleCode: localStorage.getItem("circleCode")
      ? [localStorage.getItem("circleCode")]
      : ["N"],
  });
  const [dateRangeError, setDateRangeError] = useState(false);

  const itemsPerPage = 15;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = tableData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(tableData.length / itemsPerPage);
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const formatDate = (date) => {
    const d = new Date(date);
    return `${String(d.getMonth() + 1).padStart(2, "0")}/${String(
      d.getDate()
    ).padStart(2, "0")}/${d.getFullYear()}`;
  };

  const wareHouseData = async () => {
    try {
      const response = await axios.get(`${baseUrl}warehouse/list`);
      const res = response.data.successList;
      setdefaultWHList(res);
      setwarehouseList(res.filter((e) => e.stateCode == filters.state));
    } catch (err) {
      console.error("Error fetching warehouse details:", err);
    }
  };

  useEffect(() => {
    setwarehouseList(defaultWHList.filter((e) => e.stateCode == filters.state));
  }, [filters.state]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        warehouseDropdownRef.current &&
        !warehouseDropdownRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    wareHouseData();
  }, []);

  const fetchData = async () => {
    setCurrentPage(1);
    setIsLoading(true);
    try {
      const url = `${baseUrl}report/order`;
      let params = {
        state: filters.state,
        circleCode: filters.circleCode.join(","),
        fromDate: formatDate(filters.fromDate),
        toDate: formatDate(filters.toDate),
      };
      if (filters.orderId) {
        params.orderId = filters.orderId;
      }
      if (filters.patientId) {
        params.patientId = filters.patientId;
      }
      if (filters.enquiryId) {
        params.enquiryId = filters.enquiryId;
      }
      const response = await axios.get(url, { params });
      const data = response?.data?.successList || [];
      setTableData(data);
    } catch (error) {
      console.error("API Error:", error);
      setTableData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const navigate = useNavigate();

  const validateDateRange = (fromDate, toDate) => {
    const start = new Date(fromDate);
    const end = new Date(toDate);
    const diffTime = Math.abs(end - start);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays <= 14;
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;

    if (name === "fromDate" || name === "toDate") {
      const isValidRange = validateDateRange(
        name === "fromDate" ? value : filters.fromDate,
        name === "toDate" ? value : filters.toDate
      );
      setDateRangeError(!isValidRange);
    }

    setFilters((prev) => ({ ...prev, [name]: value }));
    setCurrentPage(1);
  };

  const handleReportTypeChange = (e) => {
    const selected = e.target.value;
    setFilters((prev) => ({ ...prev, reportType: selected }));

    // B2B Partners screens disabled — drop B2B redirect branch.
    // if (selected === "B2B") {
    //   navigate("/b2bOrderReport");
    // } else
    if (selected === "B2C") {
      navigate("/b2cOrderReport");
    } else if (selected === "EYEWEAR") {
      navigate("/eyewearOrderReport");
    }
  };

  const handleExport = async () => {
    setIsLoading(true);
    try {
      const exportUrl = `${baseUrl}export/download/order`;
      const params = new URLSearchParams({
        state: filters.state,
        circleCode: filters.circleCode.join(","),
        fromDate: formatDate(filters.fromDate),
        toDate: formatDate(filters.toDate),
      });
      if (filters.orderId) {
        params.orderId = filters.orderId;
      }
      if (filters.patientId) {
        params.patientId = filters.patientId;
      }
      if (filters.enquiryId) {
        params.enquiryId = filters.enquiryId;
      }
      const response = await axios.get(`${exportUrl}?${params.toString()}`, {
        responseType: "blob",
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.ms-excel",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `CHE_Engage_Order_Report_${filters.fromDate}_to_${filters.toDate}.xlsx`;
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Export failed", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const renderPagination = () => {
    if (totalPages <= 1) return null;

    const visiblePages = 5;
    let startPage = Math.max(1, currentPage - Math.floor(visiblePages / 2));
    let endPage = startPage + visiblePages - 1;

    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(1, endPage - visiblePages + 1);
    }

    const pageButtons = [];
    for (let i = startPage; i <= endPage; i++) {
      pageButtons.push(
        <button
          key={i}
          onClick={() => setCurrentPage(i)}
          className={`w-8 h-8 text-sm border rounded-full ${currentPage === i
            ? "bg-blue-500 text-white"
            : "hover:bg-gray-200 text-gray-700"
            }`}
        >
          {i}
        </button>
      );
    }

    return (
      <div className="flex flex-wrap items-center justify-center gap-2 mt-6">
        <button
          onClick={() => setCurrentPage(1)}
          disabled={currentPage === 1}
          className="text-lg disabled:opacity-50"
        >
          «
        </button>
        <button
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
          className="text-lg disabled:opacity-50"
        >
          ‹
        </button>
        {pageButtons}
        <button
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
          disabled={currentPage === totalPages}
          className="text-lg disabled:opacity-50"
        >
          ›
        </button>
        <button
          onClick={() => setCurrentPage(totalPages)}
          disabled={currentPage === totalPages}
          className="text-lg disabled:opacity-50"
        >
          »
        </button>
      </div>
    );
  };

  const handleSearch = () => {
    if (dateRangeError) {
      return; // Prevent search if date range is invalid
    }
    fetchData();
  };

  return (
    <div className="p-3 sm:p-6 bg-white rounded-lg">
      <div className="mb-4 text-sm text-gray-500">
        <span className="text-gray-700 font-medium">Reports</span> &gt;{" "}
        <span className="text-blue-600 font-semibold">
          CHE/Engage Order Report
        </span>
      </div>

      <div className="flex flex-wrap items-center gap-3 mb-6">
        <div>
          <select
            className="border px-4 py-2 rounded w-[160px]"
            name="reportType"
            value={filters.reportType}
            onChange={handleReportTypeChange}
          >
            <option value="CHE/Engage">CHE/Engage</option>
            {/* B2B Partners screens disabled — hide B2B source option. */}
            {/* <option value="B2B">B2B</option> */}
            <option value="B2C">B2C</option>
            <option value="EYEWEAR">Eye wear</option>
          </select>
        </div>
        {loggedInUser?.roleCode === "PHHEAD" && (
          <>
            <select
              name="state"
              value={filters.state}
              onChange={handleFilterChange}
              className="border px-3 py-2 w-48 rounded-lg"
            >
              {stateList.map((s) => (
                <option key={s.value} value={s.value}>
                  {s.name}
                </option>
              ))}
            </select>
            <div className="flex items-center">
              <div className="relative" ref={warehouseDropdownRef}>
                <div
                  className="flex items-center justify-between border rounded-lg px-3 py-2 w-64 cursor-pointer"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  <span className="truncate">
                    {filters.circleCode.length > 0
                      ? `${filters.circleCode.length} warehouse(s) selected`
                      : "Select Warehouses"}
                  </span>
                  <svg
                    className={`w-4 h-4 ml-2 transition-transform ${dropdownOpen ? "rotate-180" : ""
                      }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
                {dropdownOpen && (
                  <div className="absolute z-50 w-full mt-1 bg-white border rounded-lg shadow-lg max-h-60 overflow-y-auto">
                    {warehouseList.map((warehouse) => {
                      const checked = filters.circleCode.includes(
                        warehouse.circleCode
                      );
                      return (
                        <label
                          key={warehouse.pharmacyCode}
                          className="flex items-center px-3 py-2 cursor-pointer hover:bg-gray-100"
                        >
                          <input
                            type="checkbox"
                            checked={checked}
                            onChange={(e) => {
                              let updated = [...filters.circleCode];
                              if (e.target.checked) {
                                updated.push(warehouse.circleCode);
                              } else {
                                updated = updated.filter(
                                  (c) => c !== warehouse.circleCode
                                );
                              }
                              setFilters((prev) => ({
                                ...prev,
                                circleCode: updated,
                              }));
                            }}
                            className="mr-2"
                          />
                          {warehouse.pharmacyName}
                        </label>
                      );
                    })}
                  </div>
                )}
              </div>
              {filters.circleCode.length > 0 && (
                <button
                  onClick={() =>
                    setFilters((prev) => ({ ...prev, circleCode: [] }))
                  }
                  className="text-red-500 text-sm ml-2 whitespace-nowrap"
                  style={{ marginLeft: "8px" }}
                >
                  Reset
                </button>
              )}
            </div>
          </>
        )}
        <input
          type="date"
          name="fromDate"
          className={`border px-4 py-2 rounded ${dateRangeError ? "border-red-500" : ""}`}
          value={filters.fromDate}
          onChange={handleFilterChange}
        />
        <input
          type="date"
          name="toDate"
          className={`border px-4 py-2 rounded ${dateRangeError ? "border-red-500" : ""}`}
          value={filters.toDate}
          onChange={handleFilterChange}
        />
        {dateRangeError && (
          <div className="text-red-500 text-sm w-full mt-1">
            Date range cannot exceed 2 weeks (14 days).
          </div>
        )}
        <input
          type="text"
          name="orderId"
          className="border px-4 py-2 rounded"
          placeholder="Type Order ID"
          value={filters.orderId}
          onChange={handleFilterChange}
        />
        <input
          type="text"
          name="enquiryId"
          className="border px-4 py-2 rounded"
          placeholder="Type Enquiry ID"
          value={filters.enquiryId}
          onChange={handleFilterChange}
        />
        <input
          type="text"
          name="patientId"
          className="border px-4 py-2 rounded"
          placeholder="Type PatientId"
          value={filters.patientId}
          onChange={handleFilterChange}
        />
        <div>
          <button
            className={`flex items-center gap-2 ${dateRangeError ? "bg-gray-400 cursor-not-allowed" : "bg-blue-500 hover:bg-blue-600"
              } text-white px-4 py-2 rounded-lg shadow-sm transition`}
            onClick={handleSearch}
            disabled={isLoading || dateRangeError}
          >
            <HiMagnifyingGlass className="h-5 w-5" />
            <span className="text-base font-medium">Search</span>
          </button>
        </div>
        <div>
          <button
            className="flex items-center gap-2 border border-gray-300 text-gray-600 px-4 py-2 rounded-full shadow-sm hover:bg-gray-100 transition"
            onClick={handleExport}
            disabled={isLoading}
          >
            <HiOutlineArrowUpTray className="h-5 w-4 text-indigo-400" />
            <span className="text-base font-medium">Export Excel</span>
          </button>
        </div>
      </div>

      {isLoading ? (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
        </div>
      ) : (
        <>
          <div className="overflow-x-auto rounded-lg shadow-md">
            <table className="min-w-full border text-sm text-[#1d2f5b] text-semi">
              <thead className="bg-gray-100 text-left">
                <tr>
                  {columns.map((column, index) => (
                    <th key={index} className="px-4 py-2 border">
                      {column.header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {currentItems.length > 0 ? (
                  currentItems.map((row, index) => (
                    <tr key={index} className="even:bg-gray-50">
                      {columns.map((column, colIndex) => {
                        let cellValue = row[column.field] || "-";

                        if (
                          column.field === "confirmedDate" ||
                          column.field === "consignmentDate" ||
                          column.field === "billingDate"
                        ) {
                          cellValue = row[column.field]
                            ? fixMonthDisplay(
                              row[column.field],
                              "MM/DD/YYYY hh:mm:ss"
                            )
                            : "-";
                        } else if (column.field === "procedureStatus") {
                          cellValue =
                            row[column.field] == 7 ||
                              row["orderStatus"] == 9 ||
                              row["orderStatus"] == 3
                              ? "Cancelled"
                              : row[column.field] == 0
                                ? "Received"
                                : "Confirmed";
                        } else if (column.field === "sentToSaveo") {
                          cellValue = row[column.field] === 1 ? "Saveo" : "Manual";
                        }

                        return (
                          <td
                            key={colIndex}
                            className="px-4 py-2 text-gray-700"
                            title={
                              typeof cellValue === "string" ? cellValue : ""
                            }
                          >
                            {cellValue}
                          </td>
                        );
                      })}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={columns.length}
                      className="px-4 py-6 text-center text-gray-500"
                    >
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {renderPagination()}
        </>
      )}
    </div>
  );
};

export default CheEngageOrderReports;
